var vote = {
	selectors: {
		email: 'input[name="voting-email"]',
		step: '.voting__step--',
	},
	emailAllow: '@kooperativa.cz',
	init: function () {
		var self = this;

		jQuery('[vote-to-step]').on('click', function (event) {
			event.preventDefault();

			self.voteNextStep($(this).attr('vote-to-step'));
		});

		jQuery('[vote-send]').on('click', function (event) {
			event.preventDefault();

			self.vote(this);
		});
	},
	vote(element) {
		var self = this;

		var email = element.parentElement.querySelector(self.selectors.email);
		var post_id = element.getAttribute('pid');

		if (self.validateEmail(email.value) && email.value.includes(self.emailAllow)) {
			self.voteControl(post_id, email.value);
		} else {
			console.log('sorry bro');
		}
	},
	voteControl(post_id, email) {
		var self = this;

		jQuery.ajax({
			type: 'POST',
			url: themeVars.ajax_url,
			data: {
				action: 'control_story_vote',
				post_id: post_id,
				email: email,
			},
			success: function (response) {
				var step = document.querySelector(self.selectors.step + '3');
				step.querySelector('h3').innerHTML = response['data']['title'];
				step.querySelector('p').innerHTML = response['data']['text'];

				self.voteNextStep(3);
			},
			error: function (errorThrown) {
				console.log(errorThrown);
			},
		});
	},
	voteNextStep(toStep) {
		var self = this;

		var prevStep = toStep - 1;
		document.querySelector(self.selectors.step + prevStep).classList.remove('active');
		document.querySelector(self.selectors.step + toStep).classList.add('active');
	},
	validateEmail(email) {
		const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(email);
	},
};

export { vote };
